import { Controller } from "@hotwired/stimulus"

// Obsługuje kopiowanie prompta AI i logowanie do Noe::Conversation
export default class extends Controller {
  static targets = ["textarea", "copyBtn"]
  static values = {
    logUrl: String,
    promptCode: String,
    copiedLabel: String,
    copyLabel: String,
  }

  connect() {
    this.conversationId = null
    this.origContent = this.textareaTarget.value
    this.logTimer = null
    this.dirty = false
    this._selectSuggestions()
  }

  _selectSuggestions() {
    const ta = this.textareaTarget
    const text = ta.value
    if (!text) return
    const lines = text.split("\n")
    let startIdx = -1
    let endIdx = -1
    let pos = 0
    for (let i = 0; i < lines.length; i++) {
      if (lines[i].startsWith("- ")) {
        if (startIdx === -1) startIdx = pos
        endIdx = pos + lines[i].length
      }
      pos += lines[i].length + 1
    }
    if (startIdx !== -1) {
      ta.focus()
      ta.setSelectionRange(startIdx, endIdx)
    }
  }

  copy() {
    const text = this.textareaTarget.value
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
    } else {
      const ta = document.createElement("textarea")
      ta.value = text
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      document.execCommand("copy")
      document.body.removeChild(ta)
    }
    const btn = this.copyBtnTarget
    btn.textContent = this.copiedLabelValue
    setTimeout(() => { btn.textContent = this.copyLabelValue }, 2000)
    this._logPrompt()
  }

  // Ctrl+C / Cmd+C w textarea
  keyboardCopy(e) {
    if ((e.ctrlKey || e.metaKey) && e.key === "c") {
      this._logPrompt()
    }
  }

  inputChanged() {
    this.dirty = true
    clearTimeout(this.logTimer)
    this.logTimer = setTimeout(() => { this._flushIfDirty() }, 2000)
  }

  blur() {
    clearTimeout(this.logTimer)
    this._flushIfDirty()
  }

  _flushIfDirty() {
    if (this.dirty && this.textareaTarget.value !== this.origContent) {
      this._logPrompt()
      this.origContent = this.textareaTarget.value
      this.dirty = false
    }
  }

  // Obcina API token z treści przed zapisem (Bearer ..., api_token=...)
  _stripToken(text) {
    return text
      .replace(/(Authorization:\s*Bearer\s+)\S+/gi, "$1[REDACTED]")
      .replace(/(api_token=)\S+/gi, "$1[REDACTED]")
  }

  _logPrompt() {
    const content = this._stripToken(this.textareaTarget.value.trim())
    if (!content) return
    const body = { content, prompt_code: this.promptCodeValue || "" }
    if (this.conversationId) body.conversation_id = this.conversationId
    fetch(this.logUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]").content,
      },
      body: JSON.stringify(body),
    })
      .then(r => r.json())
      .then(data => {
        if (data.conversation_id) this.conversationId = data.conversation_id
      })
  }
}
